// Adds a 'visible' class the first time an element appears in viewport

import $ from "jquery";

/* istanbul ignore next */
function init(): void {
  if ($(".js-visible").length) {
    if (typeof IntersectionObserver !== "undefined") {
      const callback = function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const $entryTarget = $(entry.target);
            $entryTarget.addClass("visible");
          }
        });
      };

      const options = {
        rootMargin: "0px",
        threshold: 0,
      };

      const observer = new IntersectionObserver(callback, options);
      $(".js-visible").each(function () {
        observer.observe($(this)[0]);
      });
    } else {
      // Fallback for browsers which do not support InteractionObserver
      $(".js-visible").addClass("visible");
    }
  }
}

export default { init };
